import { render, staticRenderFns } from "./ClassNewView.vue?vue&type=template&id=8751f550"
import script from "./ClassNewView.vue?vue&type=script&lang=js"
export * from "./ClassNewView.vue?vue&type=script&lang=js"
import style0 from "./ClassNewView.vue?vue&type=style&index=0&id=8751f550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports